import type { SVGProps } from 'react';
const SvgTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.472 3.827A1.29 1.29 0 0 1 10.678 3h4.644c.535 0 1.017.33 1.206.827l.65 1.718h3.858c.534 0 .964.426.964.955s-.43.955-.964.955H4.964A.957.957 0 0 1 4 6.5c0-.529.43-.955.964-.955h3.857zM6.073 21.646l-.92-12.282H7.09l.908 12.138a.64.64 0 0 0 .643.589h8.722a.645.645 0 0 0 .643-.589l.908-12.138h1.933l-.92 12.278A2.563 2.563 0 0 1 17.363 24H8.641a2.563 2.563 0 0 1-2.564-2.358z"
    />
  </svg>
);
export default SvgTrash;
